// this static definition of CC provider names based on their EN slug is
// expected to be a short-term solution to be replaced by an API-based one

// when no FR slug is provided, the EN slug will be used in the Rh landing page URL for both languages

const PROVIDER_INFO = {
    'affirm-financial': {
        name_en: 'Affirm Financial',
        name_fr: 'Affirm Financial',
    },

    'american-express': {
        name_en: 'American Express',
        name_fr: 'American Express',
    },

    'bank-of-montreal': {
        name_en: 'Bank of Montreal',
        name_fr: 'Banque de Montréal',

        slug_fr: 'banque-de-montreal',
    },
    
    'brim-financial': {
        name_en: 'Brim Financial',
        name_fr: 'Financière Brim',
        
        slug_fr: 'financiere-brim',
    },
    
    'canadian-tire': {
        name_en: 'Canadian Tire',
        name_fr: 'Canadian Tire',
    },

    'capital-one': {
        name_en: 'Capital One',
        name_fr: 'Capital One',
    },

    chase: {
        name_en: 'Chase',
        name_fr: 'Chase',
    },

    cibc: {
        name_en: 'CIBC',
        name_fr: 'Banque CIBC',

        slug_fr: 'banque-cibc',
    },

    desjardins: {
        name_en: 'Desjardins',
        name_fr: 'Desjardins',
    },

    'home-trust': {
        name_en: 'Home Trust',
        name_fr: 'Home Trust',
    },

    hsbc: {
        name_en: 'HSBC',
        name_fr: 'HSBC',
    },

    'hudsons-bay': {
        name_en: 'Hudson’s Bay',
        name_fr: 'Hudson’s Bay',
    },

    koho: {
        name_en: 'KOHO',
        name_fr: 'KOHO',
    },
    
    'laurentian-bank': {
        name_en: 'Laurentian Bank',
        name_fr: 'Banque Laurentienne',

        slug_fr: 'banque-laurentian',
    },

    mbna: {
        name_en: 'MBNA',
        name_fr: 'MBNA',
    },

    meridian: {
        name_en: 'Meridian Credit Union Ltd.',
        name_fr: 'Meridian Credit Union Ltd.',
    },

    'national-bank': {
        name_en: 'National Bank',
        name_fr: 'Banque Nationale du Canada',

        slug_fr: 'banque-nationale-du-canada',
    },

    'neo-financial': {
        name_en: 'Neo Financial',
        name_fr:  'Neo Financial',
    },
    
    'pc-financial': {
        name_en: 'PC Financial',
        name_fr: 'Le Choix du Président Services Financiers',

        slug_fr: 'le-choix-du-president-services-financiers',
    },

    'peoples-trust-company': {
        name_en: 'People’s Trust Company',
    },
    
    plastk: {
        name_en: 'Plastk',
    },
    
    'rbc-royal-bank': {
        name_en: 'RBC Royal Bank',
        name_fr: 'Banque Royale',

        slug_fr: 'banque-royale',
    },

    'refresh-financial': {
        name_en: 'Refresh Financial',
        name_fr: 'Refresh Financière',

        slug_fr: 'refresh-financiere',
    },

    'rogers-bank': {
        name_en: 'Rogers Bank',
        name_fr: 'Rogers Bank',
    },

    scotiabank: {
        name_en: 'Scotiabank',
        name_fr: 'Banque Scotia',

        slug_fr: 'banque-scotia',
    },

    tangerine: {
        name_en: 'Tangerine',
        name_fr: 'Tangerine',
    },

    'td-bank': {
        name_en: 'TD',
        name_fr: 'Banque TD',

        slug_fr: 'banque-td',
    },

    walmart: {
        name_en: 'Walmart',
        name_fr: 'Walmart',
    },
};


export default PROVIDER_INFO;
